<template>
  <div :class="$setClasses">
    <template v-if="rating">
      <Stars :class="$vClass('stars')"
              :note="rating"
              :note-max="5"/>
      <div :class="$vClass('content')">
        <span :class="$vClass('content__rating')">{{ rating }}/5</span>
        <span class="u-margin-right-small u-margin-left-xxxsmall">
          {{ $t('comparator.offers.offer.count', {count})}}</span>
        <nxt-popover v-if="!hideRates"
                     :popper-class="$vClass('popover')">
          <offer-rates :rates="rates"></offer-rates>
          <template slot="reference">
            <font-awesome-icon :icon="['fal', 'circle-chevron-right']"
                               class="u-cursor-pointer --chevron">
            </font-awesome-icon>
          </template>
        </nxt-popover>
      </div>
    </template>
    <template v-else>
      <span v-if="!hideNoRating"
            :class="$vClass('empty')">
        {{$t('comparator.offers.offer.rating.no')}}
      </span>
    </template>
  </div>
</template>

<script>
import OfferRates from './OfferRates.vue';
import Stars from '../../../utils/components/Stars.vue';

export default {
  name: 'OfferRating',
  nameClassStyle: 'offer-rating',
  components: {
    OfferRates,
    Stars,
  },
  props: {
    rates: Object,
    displayRates: Boolean,
    hideNoRating: Boolean,
    rating: {
      type: Number,
      default: 0,
    },
    count: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    hideRates() {
      return !this.displayRates || !this.rates;
    },
  },
};
</script>

<style lang="scss">
@import '../../../assets/scss/components/OfferRating';
</style>
